import { HttpContextToken } from '@angular/common/http';

/**
 * Set on background requests whose failures must not show a toast
 * (for example tenant branding on app start). Session expiry is still handled.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
